import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-10a156cd")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_words_form = _resolveComponent("words-form")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_page_header, {
      class: "margin-bottom-10",
      onBack: _ctx.goBack,
      content: "基础信息"
    }, null, 8, ["onBack"]),
    _createVNode(_component_el_divider),
    _createVNode(_component_words_form, { words: _ctx.words }, null, 8, ["words"])
  ], 64))
})